if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"applicant","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(3(21|38|76)|586|758)|2(056|247|359|484|712|814)|3(508|69|8)|4((2|37|43)2|046|105|443|526|744)|5(14|244|252|616|638)|7(021|276|302)|8(8(30|8|93)|445)|9(2(1|30|80|93)|429)|6456|6904)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}